






























































import { Component, Vue, Watch } from 'vue-property-decorator';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

@Component({
    components: {
        Datepicker
    }
})
export default class FilterBox extends Vue {
    private eventEmit = {
        eventFilterChange: 'eventFilterChange'
    };

    private startDate = moment(Date.now()).subtract(3, 'months').startOf('month').toDate();
    private endDate = moment(Date.now()).endOf('month').toDate();
    searchText = '';

    @Watch('startDate', { immediate: true, deep: true })
    private async watchStartDate() {
        if (this.startDate) {
            this.onTextSearchChange();
        }
    }

    @Watch('endDate', { immediate: true, deep: true })
    private async watchEndDate() {
        if (this.endDate) {
            this.onTextSearchChange();
        }
    }

    onTextSearchChange() {
        this.$emit(this.eventEmit.eventFilterChange, {
            searchText: this.searchText,
            startDate: moment(this.startDate).format('YYYY-MM-DD HH:mm:ss'),
            endDate: moment(this.endDate).format('YYYY-MM-DD HH:mm:ss')
        });
    }
}
